<script>
export default {
  props: {
    item: {
      type: Object,
    },
    link: {
      type: String,
    },
  },
};
</script>
<template>
  <Card v-if="item" class="p-t-c-li">
    <CardTitle>
      {{ item.name }}
      <router-link
        slot="btn"
        :to="`${link}/${item.id}`"
      >
        <BtnPrimary>от {{item.cost | price}} {{'rub' | currency}}</BtnPrimary>
      </router-link>
    </CardTitle>
    <CardBody flex>
      <div class="p-t-c-li__preview">
        <img
          v-if="item.preview"
          :src="item.preview"
          alt=""
        >
      </div>
      <div class="p-t-c-li__info">
        <div class="p-t-c-li__group">
          <span>Дата:</span>
          {{ item.date }}
        </div>
        <div
          v-if="item.type"
          class="p-t-c-li__group"
        >
          <span>Тип тура:</span>
          {{ item.type.label }}
        </div>
        <div class="p-t-c-li__group">
          <span>Описание:</span>
          <div class="p-t-c-li__description">
            {{ item.description }}
          </div>
        </div>
        <div class="p-t-c-li__group">
          <span>Другие даты:</span>
          <div class="p-t-c-li__dates">
            <router-link
              v-for="date in item.dates"
              :key="date.value"
              :to="`${link}/${date.value}`"
            >
              <BtnPrimary>{{date.label}}</BtnPrimary>
            </router-link>
          </div>
        </div>
      </div>
    </CardBody>
  </Card>
</template>
<style lang="scss">
  .p-t-c-li {
    &__group {
      margin-bottom: 8px;
      font-size: 16px;

      span {
        display: inline-block;
        width: 150px;
        font-weight: 700;
      }
    }

    &__preview {
      width: 180px;
      height: 180px;
      margin-right: 16px;
      flex-shrink: 0;
      line-height: 0;
      display: flex;
      align-items: center;
      justify-content: center;

      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }

    &__dates {
      margin-top: 8px;
      a {
        margin-right: 8px;
      }
    }
  }

  @media (max-width: 500px) {
    .p-t-c-li {
      .card-title {
        display: block;
      }

      .card-title__name {
        height: auto;
      }

      .card-body--flex {
        display: block;
      }

      .card-title__btn {
        justify-content: flex-end;
        margin: 0;
        padding-top: 8px;
      }
    }
    .p-t-c-li__preview {
      width: 100%;
      margin: 0 0 16px 0;
    }
  }
</style>
